import React, { useState } from "react";
import { Text } from "@sitecore-jss/sitecore-jss-react";

import styles from "./FlowLayout.module.scss";

export const FlowLayout = ({ children, Sidebar, ...props }) => {
  const [isOpenedSidebar, setIsOpenedSidebar] = useState(false);

  const toggleSidebar = () => {
    setIsOpenedSidebar((prev) => !prev);
  };

  return (
    <section className={styles.flowLayout__wrapper}>
      <div className={styles.flowLayout__container}>
        {children}
        <div className={styles.flowLayout__footer} onClick={toggleSidebar}>
          <span
            className={
              !isOpenedSidebar
                ? `${styles.flowLayout__footer__span} ${styles["flowLayout__footer__span-right"]}`
                : "hidden"
            }
          >
            <Text field={props.fields.CheckCalculation}></Text>
          </span>
          <span
            className={
              !isOpenedSidebar
                ? "hidden"
                : `${styles.flowLayout__footer__span} ${styles["flowLayout__footer__span-left"]}`
            }
          >
            <Text field={props.fields.GoBackText}></Text>
          </span>
        </div>
      </div>
      <div
        className={`${styles["flowLayout__sidebar-wrapper"]} ${
          isOpenedSidebar ? styles["flowLayout__sidebar-wrapper--visible"] : ""
        }`}
      >
        {Sidebar}
      </div>
    </section>
  );
};
